
import { Component, OnInit } from '@angular/core';

import { TwitterService } from './twitter.service';

@Component({
  selector: 'social-twitter-card',
  template: `
    <div class="content">
      <div class="d-flex flex-column justify-content-center aling-items-center">
        <div class="d-flex justify-content-center aling-items-center">
          <social-twitter-img></social-twitter-img>
        </div>
        <h4 class="text-center">{{ data.name }}</h4>
        <social-twitter-btn class="d-flex justify-content-center aling-items-center"></social-twitter-btn>
      </div>
    </div>
  `,
  styles: [`
    .content{
      background: #f2f2f2;
      border: 1px solid #dbdbdb;
      margin: 5px;
      padding: 10px;
      max-width:200px;
    }
  `]
})
export class TwitterCardComponent implements OnInit {
  data: any = {};

  constructor(private service: TwitterService) { }

  ngOnInit() {
    this.service.subject.subscribe(data => {
      this.data = data;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/social/twitter/twitter-card.component.ts